import { camelToSnake, keysToSnakeObject } from '@shared/helpers/camelToSnake';

type InputItem = { value: string; selected: string };

type Role = {
    value: string;
    combination: Record<string, string>;
};

export const getPresetValue = <T extends Role>(accessList: InputItem[], ROLES: T[]): string => {
    const ROLE_KEYS = Object.keys(ROLES[0].combination).map((key) => camelToSnake(key));

    const inputMap: Record<string, string> = {};

    // eslint-disable-next-line no-restricted-syntax
    for (const item of accessList) inputMap[item.value] = item.selected;

    const normalizedInput: Record<string, string> = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const k of ROLE_KEYS) normalizedInput[k] = inputMap[k];

    const found = ROLES.find(({ combination }) => {
        const snakeCombination = keysToSnakeObject(combination);
        // eslint-disable-next-line no-restricted-syntax
        for (const k of ROLE_KEYS) {
            if (!normalizedInput[k]) {
                continue;
            }
            if (normalizedInput[k] !== snakeCombination[k]) return false;
        }
        return true;
    });

    return found?.value ?? 'userSettings';
};
